import axios from '@/axios' 
  
export default async function setAuthData() { 
  const response = await axios.get(`/auth/me`)

  const userData = {
    ...response.data,
    status: response.status
  }

  return userData 
}